import { render, staticRenderFns } from "./suspensiones-table.vue?vue&type=template&id=d13e15d4&"
import script from "./suspensiones-table.vue?vue&type=script&lang=ts&"
export * from "./suspensiones-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports